// extracted by mini-css-extract-plugin
module.exports = {"accordions":"ViewSetup_accordions__2KIma"};